// DONT CHANGE ORDER OF FIELDS, IT WILL AFFECT USERS UI
export enum AllowedUserFieldsEnum {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  DISPLAY_NAME = 'display_name',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
  ACCOUNT_NAME = 'account_name',
  POSITION = 'position',
  AREA = 'area',
  LOCATION = 'location',
  DEPARTMENT = 'department',
  CUSTOM_1 = 'custom_1',
  CUSTOM_2 = 'custom_2',
  CUSTOM_3 = 'custom_3'
}

export const AllowedUserFieldsSet = new Set(
  Object.values(AllowedUserFieldsEnum)
)
export enum AdditionalSelfSignUpFieldsEnum {
  PASSWORD = 'password'
}

export type AllowedSelfSignUpFieldsType = AllowedUserFieldsEnum &
  AdditionalSelfSignUpFieldsEnum

const UNUSED_FIELDS_FOR_VERIFICATION = [AllowedUserFieldsEnum.ACCOUNT_NAME]

// fields, which can be used as verification fields
export const AllowedUserVerificationsFieldsSet = new Set(
  Object.values(AllowedUserFieldsEnum).filter(
    (f) => !UNUSED_FIELDS_FOR_VERIFICATION.includes(f)
  )
)

export const FORBIDDEN_TO_EDIT_USER_ADDITIONAL_FIELDS = [
  AllowedUserFieldsEnum.ACCOUNT_NAME
]

// fields, which user can edit after first login
export const AllowedToEditUserAdditionalFieldsSet = new Set(
  Object.values(AllowedUserFieldsEnum).filter(
    (f) => !FORBIDDEN_TO_EDIT_USER_ADDITIONAL_FIELDS.includes(f)
  )
)

// fields, which user can edit when setting new password / creating new acc
export const AllowedSelfSignUpFieldsSet = new Set([
  ...Object.values(AllowedUserFieldsEnum),
  ...Object.values(AdditionalSelfSignUpFieldsEnum)
])

export interface IOrganisationAccountNameLoginConfig {
  verificationFields: AllowedUserFieldsEnum[]
}

export interface IOrganisationAdditionalFieldsConfig {
  additionalFields: AllowedUserFieldsEnum[]
  privacyPolicyEnabled: boolean
  privacyPolicyUrl?: null | string
}
